/* eslint-disable security/detect-object-injection */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import { Suspense, useContext, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { Route, Navigate, Routes, useNavigate, useLocation } from 'react-router-dom';
import AnimatedPage from '../components/Animation/AnimatedPage';
import LoginPage from '../pages/auth/LoginForm';
import { ComponentsBasedOnRole } from './_nav';
import Layout from '../components/Layout'
import SearchEmptyScreen from '../components/SearchEmptyScreen';
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword';
import PageNotFound from '../pages/auth/LoginForm/Components/PageNotFound';
import EmailVerificationScreen from '../CommonMethods/EmailAddressVerification';
import ForgotResetPassword from '../pages/auth/LoginForm/Components/ForgotResetPassword';
import Noroute from '../components/Noroutes/Noroutes';
import { handleEditMessageSent } from '../redux/systemConfigSlice';
import CustomOverLay from '../components/CustomOverLay';
import { restoreAuthFromLocalStorage } from '../CommonMethods/AuthSync';

export default function NavigationRoutes(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const userType = sessionStorage.getItem('user_type');
    const rolesToMap = ComponentsBasedOnRole[userType];
    const [isAuthenticating, setIsAuthenticating] = useState(true)
    const editingUserId = useSelector((state)=>state?.systemConfigData?.editingUserId)
    const messageSent = useSelector((state)=>state?.systemConfigData?.messageSent)
    const restrictroute = useSelector(state => state?.systemConfigData?.restrict)

    useEffect(() => {
        // Check sessionStorage first
        let hasToken = sessionStorage.getItem('IdToken');
        
        // If no token in sessionStorage, try to restore from localStorage (new tab scenario)
        // BUT: Don't restore if we're on login page and localStorage has tokens but no AUTH_SYNC_KEY
        // This prevents restoring stale tokens after password update
        if (!hasToken) {
            const isOnLoginPage = location.pathname === '/';
            const hasLocalTokens = !!localStorage.getItem('IdToken');
            const hasAuthSyncKey = !!localStorage.getItem('arcm_auth_synced');
            
            // Only restore if AUTH_SYNC_KEY exists (indicates valid synced session)
            // If on login page with tokens but no sync key, tokens are stale (e.g., after password update)
            if (hasAuthSyncKey) {
                const restored = restoreAuthFromLocalStorage();
                if (restored) {
                    hasToken = sessionStorage.getItem('IdToken');
                }
            } else if (isOnLoginPage && hasLocalTokens) {
                // Stale tokens detected - clear them to prevent restore loop
                const AUTH_KEYS = ['IdToken','RefreshToken','AccessToken','email','user_id','id','user_type','session_token','first_name','last_name','currentTimestamp'];
                AUTH_KEYS.forEach(key => localStorage.removeItem(key));
                localStorage.removeItem('arcm_auth_synced');
            }
        }
        
        if (hasToken) {
            // Block authenticated access while duplicate session modal decision is pending.
            // Tokens are staged in sessionStorage only — not yet promoted to localStorage.
            if (sessionStorage.getItem('duplicate_session_pending') === 'true') {
                setIsLoggedIn(false);
                setIsAuthenticating(false);
                return;
            }
            setIsLoggedIn(true);
            setIsAuthenticating(false);
            const isFirstTimeLogin = sessionStorage.getItem('custom:is_first_time_login') === "true";
            
            // Only navigate if we're not already on the target route to prevent navigation conflicts
            if (isFirstTimeLogin && location.pathname !== '/reset') {
                navigate('/reset');
            } else if (!isFirstTimeLogin && location.pathname === '/reset') {
                navigate('/profile');
            }
        }
        else {
            setIsLoggedIn(false);
            setIsAuthenticating(false)
        }
    }, [location, navigate])
    
    useEffect(()=>{
        
        const editRoutes = ['/manage-organization-users/edit-organization-user/:id','/manage-observer/edit-observer/:id','/manage-patients/edit-patient/:id','/manage-monitoring-condition-templates/add-template/:id',]
        if(!editRoutes.includes(location.pathname)&&(editingUserId!==''||messageSent===true)){
            // dispactch(handleTargetUserEditId(''))
            // dispatch(handleEditMessageSent(false))
        }
    },[location.pathname])


    return (

        <Suspense fallback={<div></div>}>{
            <>
                {isAuthenticating ? <div><CustomOverLay Active text="Loading ARCM Organization Web Application" classKey="fixed top-0 left-0 right-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center text-white"/></div> :
                    (<Routes location={location} key={location.pathname}>
                        <Route path="/email-address-verification" element={
                            <AnimatedPage>
                                <EmailVerificationScreen />
                            </AnimatedPage>
                        } />
                        {!isLoggedIn ?
                            <>
                                <Route path="/" element={
                                    <AnimatedPage><LoginPage /></AnimatedPage>} />
                                <Route path="/reset" element={
                                    <AnimatedPage>
                                        <ResetPassword />
                                    </AnimatedPage>
                                } />
                                <Route path="/reset-new-password" element={
                                    <AnimatedPage><ForgotResetPassword /></AnimatedPage>} />

                                <Route path="/404" element={
                                    <>
                                        <SearchEmptyScreen text={"404: Page Not Found. We’re sorry, but the page you’re looking for doesn’t exist. Please check the URL and try again later."} />
                                    </>} />
                                {/*<Route
                                path="*"
                            element={<Navigate replace to="/" />} />*/}
                                <Route
                                    path="*"
                                    element={<PageNotFound />} />

                            </>
                            :
                            <>


                                <Route path="/reset" element={
                                    <AnimatedPage>
                                        <ResetPassword />
                                    </AnimatedPage>
                                } />
                                <Route element={<Layout {...props} />}>
                                    {
                                        rolesToMap !== undefined && rolesToMap.map((nav) => (
                                            <Route
                                                path={nav.path}
                                                element={
                                                    (restrictroute === 'true' || restrictroute === true) && nav.roleKey !== 'Profile' ? (
                                                        nav.roleKey === 'UpdatePassword' ? (
                                                            React.cloneElement(nav.element, props)
                                                        ) : (
                                                            <Navigate to="/profile" />
                                                        )
                                                    ) : (
                                                        React.cloneElement(nav.element, props)
                                                    )
                                                }
                                                key={nav.path}
                                            />
                                        ))
                                    }


                                </Route>
                                <Route
                                    path="*"
                                    element={<Navigate replace to="/" />}
                                />

                            </>

                        }
                        <Route
                            path="*"
                            element={
                                <Noroute/>} 
                                
                        />
                    </Routes>
                    )}
            </>
        }</Suspense>

    );
}